// extracted by mini-css-extract-plugin
module.exports = {"SidebarSocial":"_3Hbjl0_P","socialMetric":"_3ufvKmd-"};